import LoadingQuestion from 'components/LoadingComponents/LoadingQuestion';
import {Button} from 'letrus-ui';
import {useEffect, useState} from 'react';
import {EnrichedQuestion} from 'utils/types/questionnaires';
import {QuestionSubmitParams} from 'containers/PracticeTest';
import styles from './RatingQuestion.module.scss';
import IconRating from './IconRating';

export interface RatingQuestionProps {
  question: EnrichedQuestion;
  onGoBack(): void;
  goToNextQuestion(): void;
  onQuestionSubmit(params: QuestionSubmitParams): void;
  isLoading: boolean;
  isQuestionnaireFinished: boolean;
}

function RatingQuestion({
  question,
  onGoBack,
  onQuestionSubmit,
  goToNextQuestion,
  isLoading,
  isQuestionnaireFinished,
}: RatingQuestionProps): JSX.Element {
  const [rating, setRating] = useState('');

  useEffect(() => {
    setRating(question.answer ?? '');
  }, [question]);

  function handleSubmit() {
    onQuestionSubmit({
      questionId: question.id,
      answer: rating,
      responses: [],
    });

    goToNextQuestion();
  }

  return isLoading ? (
    <LoadingQuestion questionType="rating" />
  ) : (
    <article className={styles.wrapper}>
      <div className={styles.header}>
        <h1>{question.name}</h1>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{__html: question.text || ''}} />
      </div>

      <IconRating
        icon="star"
        options={5}
        answer={rating}
        readOnly={isQuestionnaireFinished}
        lowerLabel={question.lower_rating_label}
        higherLabel={question.higher_rating_label}
        onChange={(e) => setRating(e.target.value)}
        name={`rating-question-${question.id}`}
        data-testid="rating-input"
      />

      <div className={styles.controls}>
        <Button
          type="button"
          variant="secondary"
          onClick={onGoBack}
          disabled={question.order === 1}
        >
          Voltar
        </Button>
        <Button
          type="button"
          variant="primary"
          onClick={handleSubmit}
          disabled={!rating}
          data-testid="submit-button"
        >
          {question.button_text || 'Próxima'}
        </Button>
      </div>
    </article>
  );
}

export default RatingQuestion;
